import './email-footer-group.scss';

import EmailFooterGroup from './EmailFooterGroup';

export default EmailFooterGroup;
